import { FormattedMessage } from '@alltrails/shared/react-intl';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { useCallback } from 'react';
import { wrapUrlSafe } from 'utils/language_support_util';
import * as styles from './LegacyUpsell.module.scss';

export default function LegacyUpsell() {
  const languageRegionCode = useLanguageRegionCode();
  const href = wrapUrlSafe('/plus?k=savenow', languageRegionCode);

  const ref = useCallback(node => {
    if (node) {
      $.colorbox({
        html: node.innerHTML,
        fixed: true,
        scrolling: false,
        open: true,
        speed: 300,
        transition: 'fade',
        width: '630',
        height: '465',
        className: 'launch-pro-modal'
      });

      $('#cboxContent #no-thanks-upsell-button').click(() => {
        $.colorbox.close();
      });
    }
  }, []);

  return (
    <div ref={ref} className={styles.container}>
      <div className="funnel-modal" id="discount-popup-modal">
        <div className="logo-container">
          <img alt="" className="at-logo" src="https://cdn-assets.alltrails.com/assets/images/plus/logo_plus.png" />
        </div>
        <div className="text-container">
          <h3 className="discount-percent">
            <FormattedMessage defaultMessage="20% OFF" />
          </h3>
          <div className="list-container">
            <FormattedMessage defaultMessage="This is your chance - take this one-time offer to get 20% off your first year of AllTrails+" />
          </div>
        </div>
        <div className="button-container">
          <div>
            <a className="btn pro-btn" href={href}>
              <span>
                <FormattedMessage defaultMessage="Learn more" />
              </span>
            </a>
          </div>
          <button id="no-thanks-upsell-button" className="btn no-thanks-btn">
            <FormattedMessage defaultMessage="No thanks" />
          </button>
        </div>
      </div>
    </div>
  );
}
